import { render, staticRenderFns } from "./AvAccordion.vue?vue&type=template&id=304dfe65&lang=pug"
import script from "./AvAccordion.vue?vue&type=script&lang=js"
export * from "./AvAccordion.vue?vue&type=script&lang=js"
import style0 from "./AvAccordion.vue?vue&type=style&index=0&id=304dfe65&prod&lang=css&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Icon: require('/app/components/vantone/Icon.vue').default,Block: require('/app/components/generic/Block.vue').default})
